import { IonButton, IonContent, IonHeader, IonImg, IonPage, IonToolbar } from '@ionic/react';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { DEFINITIONS } from './definitionsData';

const Definitions: React.FC = () => {
  const history = useHistory();
  const [openCategory, setOpenCategory] = useState<string | null>(null);

  const toggleCategory = (category: string) => {
    setOpenCategory(openCategory === category ? null : category);
  }; 

  return (
    <IonPage className="definitions-page app-parent">
      <div className="slotcheck-header">
        <IonHeader className="small-header header-dark">
          <IonToolbar>
            <IonButton
              fill="clear"
              onClick={() => history.goBack()}
              className="icon-back"
              slot="start"
            >
              <IonImg src="assets/images/back-round.png" />
            </IonButton>
            <div className="logo header-title definitions-header-title">
              <img src="assets/icon/definitions/info.svg" alt="" className="definitions-header-icon" />
              Definitions
            </div>
          </IonToolbar>
        </IonHeader>
      </div>

      <IonContent className="definitions-content">
        <p className="definitions-subtitle">Understand the terms Slot check uses</p>

        <div className="definitions-accordion">
          {DEFINITIONS.map(({ category, terms }) => {
            const isOpen = openCategory === category;
            return (
              <div
                key={category}
                className={`definitions-category${isOpen ? ' definitions-category--open' : ''}`}
              >
                <button
                  className="definitions-category__header"
                  onClick={() => toggleCategory(category)}
                >
                  <img
                    src="assets/icon/definitions/filter.svg"
                    alt=""
                    className="definitions-category__icon"
                  />
                  <span className="definitions-category__name">{category}</span>
                  <img
                    src={`assets/icon/definitions/${isOpen ? 'chevron-down' : 'chevron-right'}.svg`}
                    alt=""
                    className="definitions-category__chevron"
                  />
                </button>

                {isOpen && (
                  <div className="definitions-term-list">
                    {terms.map(({ term, definition }) => (
                      <div key={term} className="definitions-term">
                        <p className="definitions-term__name">{term}</p>
                        <p className="definitions-term__definition">{definition}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Definitions;
